const FORBIDDEN_PROPS = [
  'm',
  'mt',
  'mb',
  'ml',
  'mr',
  'mx',
  'my',
  'p',
  'pt',
  'pb',
  'pl',
  'pr',
  'px',
  'py',
  'overflow',
  'color',
  'fontFamily',
  'fontSize',
  'fontWeight',
  'letterSpacing',
  'textAlign',
  'textTransform',
  'textOverflow',
  'textDecoration',
  'whiteSpace',
  'lineHeight',
  'border',
  'borderLeft',
  'borderRight',
  'borderTop',
  'borderBottom',
  'borderColor',
  'opacity',
  'display',
  'verticalAlign',
  'textShadow',
  'styleAs',
];

export function cleanTextProps(props: Record<string, unknown>) {
  return Object.keys(props).reduce(
    (acc, key) =>
      FORBIDDEN_PROPS.includes(key) ? acc : { ...acc, [key]: props[key] },
    {},
  );
}
